import { Inject } from "@angular/core";
import { IbaseClass } from "./ibase-class";
import { IbaseService } from "../base-service/ibase-service";
import { environment } from "src/environments/environment";
import { api } from "../services/api";
import { Subscription } from "rxjs";
import { Events, EventsName } from "../model/event";


export interface ErrorObj {
  code: number;
  message: string;
}

export interface ResFormat {
  data: any;
  error: ErrorObj;
  status: boolean;
}
export interface cfCasino {
  desktop_banners: any[];
  mobile_banners: any[];
  new_launch: any[];
  our_providers: any[];
  highlight_casino: any[];
}

export abstract class BaseClass<T> implements IbaseClass<any> {
  abstract getServices(): IbaseService<T>;
  protected subs: Subscription[] = [];
  public dateKeys = ['created_at', 'updated_at', 'matched_at', 'requested_at', 'open_date', 'market_start_time']
  public env = environment;
  public api = api;

  public isLoad = false;
  public userData = this.getLocalItem('user');
  public menu = this.getLocalItem('menu');
  public webSocketUrl: string = '';

  public events = {
    sports: Events.Sports.split(",").map((e) => { return Number(e) }),
    races: Events.Races.split(",").map((e) => { return Number(e) }),
    casino: Events.Casino.split(",").map((e) => { return Number(e) }),
    casino1: Events.Casino1.split(",").map((e) => { return Number(e) }),
    iCasino: Events.ICasino.split(",").map((e) => { return Number(e) }),
    intCasino: Events.IntCasino.split(",").map((e) => { return Number(e) }),
    royalCasino: Events.RoyalCasino.split(",").map((e) => { return Number(e) }),
    binary: Events.Binary.split(",").map((e) => { return Number(e) }),
    sportsBook: Events.SportsBook.split(",").map((e) => { return Number(e) }),
  }
  public eventsName = this.genEventsName();

  constructor() {
  }

  isLogin() {
    return ((localStorage.getItem(`${this.env.panel}id_token`)) && localStorage.getItem(`${this.env.panel}user`)) ? true : false;
  }

  redirectCompititionString(str: string) {
    return str.replace(/ /g, '-').toLowerCase();
  }

  genEventsName() {
    let menu = this.getLocalItem('menu');
    return menu ? Object.assign({}, ...menu.map((elt: any) => ({ [elt?.id]: (this.events.iCasino.includes(elt?.id)) ? EventsName.ICasino : (this.events.casino1.includes(elt?.id)) ? EventsName.Casino1 : elt.name }))) : {}
  }

   getMenuIdsArray() {
    this.menu = this.getLocalItem('menu');
    return this.menu ? this.menu.map((item: any) => item.id) : [];
  }


  UTC_to_Local_timeZone(items: any) {

    if (Array.isArray(items)) {
      items.forEach(element => {
        Object.keys(element).forEach((key, index) => {

          if (this.dateKeys.includes(key)) {
            if (element[key].includes('T')) {
              element[key] = element[key].replace('T', ' ').replace('.000000Z', '')
            }
            element[key] = new Date(element[key] + ' UTC').toString();
          }
        });
      });

    } else if (typeof (items) == 'object') {
      Object.keys(items).forEach(key => {
        if (this.dateKeys.includes(key)) {
          if (items[key].includes('T')) {
            items[key] = items[key].replace('T', ' ').replace('.000000Z', '')
          }
          items[key] = new Date(items[key] + ' UTC').toString();
        }
      });
    }
    return items;
  }

  string_to_JSON(res: any) {
    const uniqueSet = new Set(res);
    res = [...uniqueSet];
    res = res.filter((el: any) => {
      return el != null;
    });
    res.forEach((element: any, i: any) => {
      res[i] = JSON.parse(element);
    });

    return res;
  }

  pipe_string_to_JSON(res: any) {
    const uniqueSet = new Set(res);
    res = [...uniqueSet];
    res = res.filter((el: any) => {
      return el != null;
    });
    res.forEach((element: any, i: any) => {
      res[i] = element.split("|");
    });

    return res;
  }

  getLocalItem(key: string, isParse: boolean = true) {
    return (isParse) ? JSON.parse(localStorage.getItem(`${this.env.panel + key}`) as any) : localStorage.getItem(`${this.env.panel + key}`) as any;
  }

  setLocalItem(key: string, data: any, isStringify: boolean = true) {
    let item = (!isStringify) ? data : JSON.stringify(data);
    localStorage.setItem(`${this.env.panel + key}`, item);
  }

  isCommon(a: any, b: any) {
    return a.filter((o1: any) => b.some((o2: any) => o1 == o2)).length == 0;
  }

  getKeyName(e: any) {
    return (e.includes('other')) ? e.substring(1) : e
  }

  kFormatter(num: any) {
    if (num) {
      //old code
      //const n = (Math.abs(num) / 1000).toFixed(1);
      //return Math.abs(num) > 999 ? Math.sign(num) * parseFloat(n) + 'k' : Math.sign(num) * Math.abs(num);

      //new code
      if (Math.abs(num) >= 100000) {
        const n = (Math.abs(num) / 100000).toFixed(1);
        return Math.abs(num) > 99999 ? Math.sign(num) * parseFloat(n) + ' lakh' : Math.sign(num) * Math.abs(num);
      } else if (Math.abs(num) >= 1000) {
        const n = (Math.abs(num) / 1000).toFixed(1);
        return Math.abs(num) > 999 ? Math.sign(num) * parseFloat(n) + ' k' : Math.sign(num) * Math.abs(num);
      } else {
        return num;
      }
    } else {
      return '-';
    }
  }

  positiveVal(e: any) {
    return e ? Number(Math.abs(e)) : e;
  }

  subtractMinutes(numOfMinutes: number, date = new Date()) {
    date.setMinutes(date.getMinutes() - numOfMinutes);
    return date;
  }

  roundVal(e: any) {
    return e ? ~~e : e
  }

  fixedPostDecimal(e: any, num: number = 2) {
    return e ? parseFloat(e).toFixed(num) : e
  }

  gotoDiv(location: any) {
    let el = document.getElementById(location) as HTMLElement;
    if (el)
      el.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
  }

  genMarketReq(res: any) {
    let market: any[] = [];
    res.forEach((element: any) => {
      market.push('market_ids[]=' + encodeURIComponent(element.market_id));
    });

    const uniqueSet = new Set(market);
    market = [...uniqueSet];

    return market.join('&') as any;
  }

  groupBy<K, V>(list: Array<V>, keyGetter: (input: V) => K) {
    const map = new Map();
    list.forEach((item: any) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  listByTypeId(items: any, id: any) {
    const grouped = this.groupBy(items, (dat: any) => dat.event_type_id);
    return grouped.get(id) ? grouped.get(id) : [];
  }

  genListBanner() {
    let banners: any[] = [];
    if (this.env.host.isCustomBanner) {
      let ts = (Date.now() - Date.now() % 300) + '000';
      banners = [
        `https://ndexch.com/images/all/1.jpg?updatedAt=${ts}`,
        `https://ndexch.com/images/all/2.jpg?updatedAt=${ts}`,
        `https://ndexch.com/images/all/3.jpg?updatedAt=${ts}`,
        `https://ndexch.com/images/all/4.jpg?updatedAt=${ts}`,
        `https://ndexch.com/images/all/5.jpg?updatedAt=${ts}`]
    } else {
      banners = [
        'assets/img/bnr1.jpg',
        'assets/img/bnr2.jpg',
        'assets/img/bnr3.jpg',
        'assets/img/bnr4.jpg',
        'assets/img/bnr5.jpg']
    }
    return banners;
  }

  array_move(arr: any) {
    // set casino at 3rd position
    arr.forEach((element: any, i: any) => {
      element['priority'] = (this.events.sports.includes(element?.id) && i <= 3) ? i : i + 3;
    });

    const cricketItem = arr.find((item: any) => item.id === 4);
    if (cricketItem) { cricketItem.priority = 0; }

    const footballItem = arr.find((item: any) => item.id === 1);
    if (footballItem) { footballItem.priority = 1; }

    const tennisItem = arr.find((item: any) => item.id === 2);
    if (tennisItem) { tennisItem.priority = 2; }

    const casinoItem = arr.find((item: any) => item.id === 99999);
    if (casinoItem) { casinoItem.priority = 3; }

    // const casinoIItem = arr.find((item: any) => item.id === 99995);
    // if (casinoIItem) { casinoIItem.priority = 3;}

    arr.sort((a: any, b: any) => a.priority - b.priority);

    //console.log(JSON.stringify(arr));

    return arr;
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  findUpComingRace(list: any, id: any) {
    var lt = list.filter((event: any) => event.event_type_id == id);

    const now = new Date();
    const nextHour = new Date(now.getTime() + 60 * 60 * 1000);

    lt = lt.filter((race: any) => {
      const raceStartTime = new Date(race.market_start_time_format);
      return raceStartTime >= now && raceStartTime <= nextHour;
    });

    return lt;
  }

  depoWithdrawCondition() {
    this.userData = this.getLocalItem('user');
    if (this.userData && this.userData?.username != 'demo123' && ((this.userData?.branch_panel_active == 1) || (this.userData?.branch_panel_active == 2 && this.env.host.depoWithdraw == true))) {
      return true;
    }
    return false;
  }

  demoLoginDepoWithdrawCondition() {
    this.userData = this.getLocalItem('user');
    if (this.userData && (this.userData?.branch_panel_active != 0 && this.userData?.username == 'demo123' && this.env.demoDWLink != '')) {
      return true;
    }
    return false;
  }


}
